if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const activePreview = this.openedBy.closest('.product__media-item[data-media-id]');
        const activePreviewMediaId = activePreview?.dataset.mediaId?.match(/-(\d+)$/)?.[1];
        const mediaId = activePreviewMediaId || this.openedBy.getAttribute('data-media-id');

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        const activePreviewImage = activePreview?.querySelector('.product__media img');
        if (activePreviewImage && activeMedia.tagName === 'IMG') {
          activeMedia.srcset = activePreviewImage.srcset || '';
          activeMedia.sizes = activePreviewImage.sizes || activeMedia.sizes;
          activeMedia.src = activePreviewImage.currentSrc || activePreviewImage.src;
          activeMedia.alt = activePreviewImage.alt || activeMedia.alt;
        }
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
